// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"d4d6a3d1","128":"1e56be8d","532":"f45ba61e","866":"68161679","945":"a39550b4"}[chunkId] + ".chunk.css";
};